import { ChainSymbol, TokenSymbol } from './types/TokenSymbol';

export const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000';
export const ZERO_ADDRESS2 = '0x000000000000000000000000000000000000dead';


export enum BlockchainNetworkId {
  mainnet = 1,
  sepolia =11155111
}

const NativeTokens: {
  [key in BlockchainNetworkId]: TokenSymbol;
} = {
  [BlockchainNetworkId.mainnet]: TokenSymbol.ETH,
  [BlockchainNetworkId.sepolia]: TokenSymbol.ETH,
};

const ChainsInfo = {
  [BlockchainNetworkId.mainnet]: { chainSymbolName: ChainSymbol.ETH },
  [BlockchainNetworkId.sepolia]: { chainSymbolName: ChainSymbol.ETH },
};

export function getChainSymbol(chainId: BlockchainNetworkId) {
  return ChainsInfo[chainId];
}

export function getNativeTokenSymbol(chainId: BlockchainNetworkId) {
  return NativeTokens[chainId];
}

const BlockChainExplorerAddress: {
  [key in BlockchainNetworkId]: String;
} = {
  [BlockchainNetworkId.mainnet]: 'https://etherscan.io/',
  [BlockchainNetworkId.sepolia]: 'https://sepolia.etherscan.io/',
};

export const getBlockChainExplorerAddress = (chainId: BlockchainNetworkId) =>
  BlockChainExplorerAddress[chainId];

const BlockChainExplorerName: {
  [key in BlockchainNetworkId]: String;
} = {
  [BlockchainNetworkId.mainnet]: 'ETHScan',
  [BlockchainNetworkId.sepolia]: 'SepoliaScan',
};

export const getBlockChainExplorerName = (chainId: BlockchainNetworkId) =>
  BlockChainExplorerName[chainId];

const BlockChainTokenSymbol: {
  [key in BlockchainNetworkId]: String;
} = {
  [BlockchainNetworkId.mainnet]: TokenSymbol.ETH,
  [BlockchainNetworkId.sepolia]: TokenSymbol.ETH,
};

const baseEnv = process.env.REACT_APP_BASE_ENV;
export const isChainSupported = baseEnv === "DEV" ? [BlockchainNetworkId.sepolia] : [BlockchainNetworkId.mainnet];

export const DefaultTokenSymbol = TokenSymbol.ETH;
export const DefaultChainId = isChainSupported[0];

export const getTokenSymbol = (chainId: BlockchainNetworkId) =>
  BlockChainTokenSymbol[chainId] || DefaultTokenSymbol;

export enum NftFtKeys {
  NFT,
  FT,
}

export const NftFtTabs = [
  {
    label: 'NFT',
    value: NftFtKeys.NFT,
  },
  {
    label: 'FT',
    value: NftFtKeys.FT,
  },
];

